import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IElementProps, IExternalDataItem } from '../../../types/interfaces'
import { enabledWhen, visibleWhen } from './common'

const Select = (props: IElementProps) => {
  const { t } = useTranslation('common')
  const [savedExternalData, setSavedExternalData] = useState<IExternalDataItem>()
  useEffect(() => {
    const { externalData } = props
    if ((externalData?.timeStamp || 0) > (savedExternalData?.timeStamp || 0)) {
      setSavedExternalData(externalData)
    }
  }, [props.externalData])

  const optionsToRender = props.externalData?.data
    ? Object.keys(props.externalData?.data).map((key) => ({
        name: key,
        value: props.externalData?.data[key],
        enabledWhen: true,
      }))
    : props.options
        .filter((o) => visibleWhen(o.visibleWhen, props.data))
        .map((o) => ({
          name: o.name,
          value: o.value,
          enabledWhen: enabledWhen(o.enabledWhen, props.data),
        }))
  return (
    props.visible && (
      <div className={`formGroup ${props.class || ''}`}>
        <div className="labelTooltip">
          {props.translatedTooltip && (
            <>
              <div className="tooltipArea">
                <i className="icon-info"></i>
                <div className="tooltip">{props.translatedTooltip}</div>
              </div>
            </>
          )}
          <label>{props.label}</label>
        </div>
        <div className="selectArea selectfuelCard required-highlight">
          <select
            onChange={(e) => props.handleChange(props.name, e)}
            value={props.value || ''}
            disabled={props.formReadOnly || props.disabledInput}
          >
            {props.formReadOnly && !(optionsToRender?.filter((o) => o.value === props.value)?.length > 0) ? (
              <>
                <option value={props.value || ''}>{props.value || ''}</option>
              </>
            ) : (
              <>
                <option disabled={true} value="">
                  {optionsToRender.length > 0 ? t('PLEASE_SELECT_A_VALUE') : t('NO_VALUE_TO_SHOW')}
                </option>
                {optionsToRender.length > 0 &&
                  optionsToRender.map((option) => (
                    <option value={option.value} key={option.name} disabled={!option.enabledWhen}>
                      {option.name}
                    </option>
                  ))}
              </>
            )}
          </select>
          <i className="icon-bottom" />
        </div>
      </div>
    )
  )
}
export default Select
